// src/components/ui/calendar/navigation/CalendarViewToggle/CalendarViewToggle.jsx
import React from 'react';
import { Calendar, Grid3x3, List } from 'lucide-react';

// shadcn components
import { Button } from '../../../button';

import { cn } from '../../../../../utils/cn';

const CalendarViewToggle = ({
  currentView,
  onViewChange,
  compact = false,
  className = ''
}) => {
  const viewOptions = [
    {
      value: 'dayGridMonth',
      label: 'Month',
      icon: Calendar,
      shortLabel: 'M'
    },
    {
      value: 'timeGridWeek',
      label: 'Week',
      icon: Grid3x3,
      shortLabel: 'W'
    },
    {
      value: 'timeGridDay',
      label: 'Day',
      icon: List,
      shortLabel: 'D'
    }
  ];

  if (compact) {
    // Compact mode: Icon-only buttons
    return (
      <div className={cn(
        "flex items-center bg-slate-800/30 backdrop-blur-sm border border-slate-600/30 rounded-lg p-1",
        className
      )}>
        {viewOptions.map((option) => {
          const IconComponent = option.icon;
          return (
            <Button
              key={option.value}
              variant="ghost"
              onClick={() => onViewChange(option.value)}
              className={cn(
                "p-1.5 rounded transition-all duration-200 h-auto",
                currentView === option.value
                  ? "bg-blue-500/20 text-blue-300 shadow-lg shadow-blue-500/25 hover:bg-blue-500/20 hover:text-blue-300"
                  : "text-slate-400 hover:text-slate-200 hover:bg-slate-700/30"
              )}
              title={option.label}
            >
              <IconComponent className="w-4 h-4" />
            </Button>
          );
        })}
      </div>
    );
  }

  // Full mode: Icon + text buttons
  return (
    <div className={cn(
      "flex items-center bg-slate-800/30 backdrop-blur-sm border border-slate-600/30 rounded-xl p-1",
      className
    )}>
      {viewOptions.map((option) => {
        const IconComponent = option.icon;
        return (
          <Button
            key={option.value}
            variant="ghost"
            onClick={() => onViewChange(option.value)}
            className={cn(
              "flex items-center gap-2 px-3 py-2 rounded-lg transition-all duration-200 font-medium h-auto",
              currentView === option.value
                ? "bg-blue-500/20 text-blue-300 shadow-lg shadow-blue-500/25 hover:bg-blue-500/20 hover:text-blue-300"
                : "text-slate-400 hover:text-slate-200 hover:bg-slate-700/30"
            )}
          >
            <IconComponent className="w-4 h-4" />
            <span className="text-sm">{option.label}</span>
          </Button>
        );
      })}
    </div>
  );
};

export default CalendarViewToggle;